import { TableRow, TableCell, Typography, Chip, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const MAX_DISPLAYED_USERS = 3;

export default function NotificationItem({ receivers, subject, content, timeSend, pushNotificationId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  //   const { loading, data } = useQuery(PushNotificationGQLFunction.GET_ALL_PUSH_NOTIFICATIONS, {
  //     variables: { page, rowsPerPage },
  //     fetchPolicy: 'network-only',
  //   });
  //   useEffect(() => {
  //     if (!loading && data) {
  //       setTotal(data.allPushNotifications.len);
  //     }
  //   }, [loading, data, setTotal]);
  //   if (loading) return <LoadingList TABLE_HEAD={PUSH_NOTIFICATION.TABLE_HEAD} />;
  //   if (!data?.allPushNotifications.len)
  return (
    <TableRow hover onClick={() => navigate(`/push-notification/info/${pushNotificationId}`)}>
      <TableCell>
        {/* <Box style={{ minWidth: '200px', maxWidth: '200px' }}> */}
        <Stack direction="row" spacing={1} mb={'1rem'} justifyContent="flex-start" alignItems="center">
          <Typography variant="body2">{t('notify.to')} :</Typography>
          <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
            {receivers.slice(0, MAX_DISPLAYED_USERS).map((receiver, index) => (
              <Chip
                variant="outlined"
                size="small"
                // avatar={<Avatar src="static/mock-images/avatars/avatar_8.jpg" />}
                label={receiver.username}
                key={index}
                sx={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              />
            ))}
            {receivers.length > MAX_DISPLAYED_USERS && (
              <Typography variant="body2">+ {receivers.length - MAX_DISPLAYED_USERS} {t('common.more_suffix')}</Typography>
            )}
          </Stack>
        </Stack>
        <Typography variant="subtitle1" gutterBottom>
          {subject}
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}>
          {content}
        </Typography>
        <Typography variant="caption" display="block" mt={'1.5rem'} gutterBottom>
          {new Date(+timeSend).toLocaleString()}
        </Typography>
        {/* </Box> */}
      </TableCell>
    </TableRow>
  );
}
